import dayjs from 'dayjs';

import { useMemo, useRef, useState } from 'react';

import DateFilter from 'components/field/DateFilter';
import Card from 'components/global/Card';
import Skeleton from 'components/global/Skeleton';
import Typography from 'components/global/Typography';

import useLazyFetch from 'hooks/useLazyFetch';

import ChartHeader from './ChartHeader';
import * as S from './styled/DataListingCard.styled';

const DataListingCard = ({ fetchURL, title, filtered = true, defaultDay }) => {
	const [filter, setFilter] = useState({
		start: dayjs().subtract(30, 'day').endOf('day').toISOString(),
		end: dayjs().endOf('day').toISOString()
	});

	const body = useMemo(() => ({ from: filter.start, to: filter.end }), [filter]);
	const ref = useRef();
	const { data, loading } = useLazyFetch({
		url: fetchURL,
		body,
		triggerElement: ref
	});

	return (
		<Card>
			<ChartHeader
				title={title}
				filter={filtered && <DateFilter defaultDay={defaultDay} setValue={setFilter} />}
				showDivider={false}
			/>
			<S.Hr />
			<div ref={ref}>
				<>
					{data?.map((item, index) => (
						<S.ListItem key={index}>
							<Typography fontWeight="500">{item?.name}</Typography>
							<Typography fontWeight="700">{item?.quantity}</Typography>
						</S.ListItem>
					))}
					{data?.length === 0 && (
						<S.ListItem>
							<Typography>dataTable.emptyMessage</Typography>
						</S.ListItem>
					)}
					{loading && (
						<S.ListItem>
							<Skeleton width="15rem" height="2rem" />
							<Skeleton width="10rem" height="2rem" />
						</S.ListItem>
					)}
				</>
				<S.FooterWrapper>
					<Typography fontWeight="700">{title}</Typography>
					<Typography fontWeight="700">totalOrders</Typography>
				</S.FooterWrapper>
			</div>
		</Card>
	);
};

export default DataListingCard;
